import { Box, Button } from '@mui/material';
import { css, styled } from '@mui/material/styles';

interface LinkButtonProps {
  active: boolean;
}

export const Menu = styled(Box)`
  display: flex;
  width: 260px;
  min-width: 260px;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.common.white};
  flex-direction: column;
  overflow: hidden;
  padding: 20px 20px;

  filter: drop-shadow(0px 8px 5px rgba(18, 27, 33, 0.1));

  .title-menu {
    color: rgba(0, 0, 0, 0.54);
    font-family: 'Roboto';
    font-weight: 400;
    font-size: 14px;
    font-style: normal;
    margin: 0;
    line-height: 0px;
    padding-top: 20px;
  }

  .menu-side {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0;
  }

  .menu-item {
    display: flex;
    height: 40px;
  }
`;

export const Logo = styled(Box)`
  width: 100%;
  height: 50px;
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
`;

export const LinkButton = styled(Button)<LinkButtonProps>`
  flex-wrap: nowrap;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 400;
  padding-left: 5px;
  border-radius: 6px;
  text-transform: capitalize;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 15px;
  color: rgba(0, 0, 0, 0.87);
  @media (max-width: 1330px) {
    font-size: 13px;
  }

  ${props =>
    props.active === true &&
    css`
      background: #f3f3f3;
      border-radius: 6px;

      &:hover {
        border-radius: 6px;
        filter: brightness(0.8);
      }
    `}
`;
